export default "__VITE_ASSET__CnIzsCVB__"